import React, { useEffect, useState } from "react";
import Api from "../../../config/Api";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../../Components/Widget/Loader";
import { FaCheck, FaUpload } from "react-icons/fa";
import { BsFillPencilFill, BsEyeFill } from "react-icons/bs";
import StatusBadge from "../Application/Components/StatusBadge";
import { useForm } from "react-hook-form";
import ModalBox from "../../Components/Widget/ModalBox";
import Table from "../../Components/Widget/Table";
import TooltipWidget from "../../Components/Widget/TooltipWidget";
const VerifyApplications = () => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  // const ImgUrl = "https://cdn-icons-png.flaticon.com/512/219/219983.png";
  const [isLoading, setIsLoading] = useState(false);
  const [application, setApplication] = useState([]);
  const [isApplicationLoaded, setIsApplicationLoaded] = useState(false);
  // const [currentStatus, setCurrentStatus] = useState(1);
  const admin = useSelector((state) => JSON.parse(state.authentication.admin));
  //console.log('cid',admin.id);
  const [filter, setFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [perPage, setPerPage] = useState(20);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState("desc");
  const [selectedData, setSelectedData] = useState({
    id: "",
    status: "",
    amount: null,
  });
  const [isModalShow, setIsModalShow] = useState(false);

  const modalClose = () => {
    setIsModalShow(false);
    reset();
    setSelectedData({
      id: "",
      status: "",
      amount: null,
    });
  };
  const modalShow = (id, status, amount) => {
    setIsModalShow(true);
    setSelectedData({
      id,
      status,
      amount,
    });
  };

  const getStatusPayload = (status = statusFilter) =>
    status ? [status] : [1, 4];

  //Application Get
  const getApplication = async (
    status_id,
    page = 1,
    search = "",
    pageSize = perPage,
    sortByArg = sortBy,
    sortDirArg = sortDirection
  ) => {
    try {
      setIsLoading(true);
      const body = {
        status_id: status_id,
        page_no: page,
        per_page: pageSize,
      };

      if (search.trim()) {
        body.search = search.trim();
      }

      if (sortByArg) {
        body.sort_by = sortByArg;
        body.sort_direction = sortDirArg;
      }

      const res = await Api("application_list", "POST", body, true);

      if (res.data.status === 1) {
        const applicationData = Array.isArray(res.data.data) ? res.data.data : [];
        const paginationData =
          res.data.pagination &&
          typeof res.data.pagination === "object"
            ? res.data.pagination
            : res.data &&
              typeof res.data === "object" &&
              res.data.page
            ? {
                page_no: res.data.page,
                per_page: res.data.per_page,
                total_records: res.data.total,
              }
            : null;

        setApplication(applicationData);

        if (paginationData) {
          setCurrentPage(paginationData.page_no || page);
          setTotalRecords(paginationData.total_records || 0);
          setPerPage(paginationData.per_page || pageSize);
        } else {
          const total =
            res.data.total || res.data.count || applicationData.length;
          setCurrentPage(page);
          setTotalRecords(total);
          setPerPage(pageSize);
        }

        setIsApplicationLoaded(true);
      } else {
        toast.error(res.data.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    } catch (error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } finally {
      setIsLoading(false);
    }
  };
  //Application Get

  const handleSearchInput = (value) => {
    setFilter(value);

    if (value.trim() === "") {
      setCurrentPage(1);
      setResetPaginationToggle((prev) => !prev);
      getApplication(getStatusPayload(), 1, "", perPage);
    }
  };

  const handleSearch = () => {
    setCurrentPage(1);
    setResetPaginationToggle((prev) => !prev);
    getApplication(getStatusPayload(), 1, filter, perPage);
  };

  const filterStatus = (e) => {
    const status = e.target.value;
    setStatusFilter(status);
    setCurrentPage(1);
    setResetPaginationToggle((prev) => !prev);
    getApplication(status ? [status] : [1, 4], 1, filter, perPage);
  };

  useEffect(() => {
    getApplication([1, 4]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!!admin) {
      reset({
        name: admin.full_name,
      });
    }
    // eslint-disable-next-line
  }, [reset]);

  const onSubmit = async (d) => {
    // console.log(d);
    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("id", selectedData.id);

      formData.append("name", d?.name);
      formData.append("remark", d?.remark);
      formData.append("status", d?.status);
      if (d?.document.length > 0) {
        formData.append("document", d?.document[0]);
      }

      // console.log(Object.fromEntries(formData));

      const res = await Api("application_verify", "POST", formData);
      // console.log(res);

      if (res.data.status === 1) {
        toast.success(res.data.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        reset();
        modalClose();
        getApplication(getStatusPayload(), currentPage, filter, perPage);
      } else if (res.data.status === 2) {
        toast.error(res.data.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        reset();
        modalClose();
        getApplication(getStatusPayload(), currentPage, filter, perPage);
      } else {
        toast.error(res.data.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    } catch (error) {
      toast.error(error.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      name: "#",
      cell: (_row, index) => (currentPage - 1) * perPage + index + 1,
      width: "70px",
    },
    {
      name: "Application ID",
      selector: (row) => row.application_id,
      sortable: true,
      wrap: true,
    },
    {
    //   name: "Applicant Image",
    name: "Applicant Passport Photo",
      selector: (row) => (
        <img
          src={row.applicant_default_img}
          alt="Applicant"
          style={{
            height: "70px",
            width: "100px",
            objectFit: "cover",
          }}
        />
      ),
    },
    {
      name: "Applicant Info",
      selector: (row) => (
        <>
          <div className="mb-1">{row.applicant_name}</div>
          <div>{row.mobile}</div>
        </>
      ),
    },
    {
      name: "District",
      selector: (row) => row.district?.district_name,
      sortable: true,
      wrap: true,
    },
    // {
    //   name: "Status",
    //   selector: (row) => <StatusBadge status={row.status} />,
    //   sortable: true,
    //   wrap: true,

    // },
    {
        name: "Status",
        selector: (row) => {
         if(row?.payment_status === 'R'){
          return (
          <>
          <StatusBadge status={row.status} /><span style={{backgroundColor: 'red',
              color: 'white',
              padding: '4px 6px',
              borderRadius: '12px',
              fontSize: '11px',}}>Failed</span>
          </>
          );
         }
         else {
         return <StatusBadge status={row.status} />
         }
        },
        sortable: true,
        wrap: true,
      },
    {
      name: "Action",
      selector: (row) => (
        <div className="d-flex gap-1">
          <TooltipWidget title="View SDRF">
            <Link
              className="btn btn-warning btn-sm"
            //   target="_blank"
              to={`/application/${window.btoa(row.id)}`}
            >
              <BsEyeFill />
            </Link>
          </TooltipWidget>
          <TooltipWidget title="Edit SDRF">
            <button
              className="btn btn-primary  btn-sm"
              onClick={() =>
                navigate("/sdrf-1", {
                  state: {
                    id: row.id,
                    isEdit: true,
                  },
                })
              }
            >
              <BsFillPencilFill />
            </button>
          </TooltipWidget>
          <TooltipWidget title="Verify/Review SDRF">
            <button
              className="btn btn-success btn-sm"
              onClick={() => {
                modalShow(row.id, "3", row.amount);
              }}
            >
              <FaCheck />
            </button>
          </TooltipWidget>
          {/* <TooltipWidget title="Upload Documents">
            <button
              className="btn btn-info  btn-sm"
              type="button"
              onClick={() => {
                navigate("/sdrf-documents", {
                  state: {
                    id: row.id,
                  },
                });
              }}
            >
              <FaUpload />
            </button>
          </TooltipWidget> */}
        </div>
      ),
      minWidth: "180px",
    },
  ];

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getApplication(getStatusPayload(), page, filter, perPage);
  };

  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
    setCurrentPage(1);
    setResetPaginationToggle((prev) => !prev);
    getApplication(getStatusPayload(), 1, filter, newPerPage);
  };

  const handleSort = (column, direction) => {
    const colMap = {
      "Application ID": "application_id",
      "District": "district_name",
      "Aadhar No": "aadhar_no",
      "Status": "status",
    };
    const field = colMap[column.name] || "";
    setSortBy(field);
    setSortDirection(direction);
    setCurrentPage(1);
    getApplication(getStatusPayload(), 1, filter, perPage, field, direction);
  };

  return (
    <>
      <div className="bg-white p-3 rounded p-3 shadow">
        <div className="mb-3">
          <div className="row g-2">
            <div className="col-lg-4 col-md-4">
              <h5 className="text-dark">Verify Applications</h5>
            </div>
            <div className="col-lg-8 col-md-8">
              <div className="">
                <div className="row g-2">
                  <div className="col-sm-6 col-lg-3">
                    <div className="">
                      <select
                        className="form-select"
                        name="status"
                        onChange={(e) => filterStatus(e)}
                        disabled={isLoading}
                      >
                        <option value="">All Status</option>
                        <option value="1">Pending</option>
                        <option value="4">Nodal Officer Review</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-sm-6 col-lg-7">
                    <div className="">
                      <input
                        type="text"
                        placeholder="Search Application"
                        className="form-control"
                        value={filter}
                        onChange={(e) => handleSearchInput(e.target.value)}
                        disabled={isLoading}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleSearch();
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-lg-2">
                    <button
                      type="button"
                      className="btn btn-primary w-100"
                      onClick={handleSearch}
                      disabled={isLoading}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isApplicationLoaded && (
          <div className="mb-3">
            <small className="text-muted">
              Showing {totalRecords === 0 ? 0 : (currentPage - 1) * perPage + 1} to{" "}
              {totalRecords === 0 ? 0 : Math.min(currentPage * perPage, totalRecords)} of{" "}
              {totalRecords} verify applications
            </small>
          </div>
        )}
        <div>
          {isApplicationLoaded ? (
            <Table
              columns={columns}
              data={application}
              progressPending={isLoading}
              pagination
              paginationServer
              paginationTotalRows={totalRecords}
              paginationDefaultPage={currentPage}
              paginationPerPage={perPage}
              paginationRowsPerPageOptions={[10, 20, 50, 100]}
              paginationResetDefaultPage={resetPaginationToggle}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              sortServer
              onSort={handleSort}
            />
          ) : (
            <Loader />
          )}
        </div>
      </div>

      <ModalBox show={isModalShow} hide={modalClose} title="Verify SDRF">
        <div className="p-2">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row g-3">
              {/* <div className="col-12">
                <div className="alert alert-warning m-0 p-2 fw-bold">
                  Are you sure you want to Verify this SDRF Form?
                </div>
              </div> */}
              <div className="col-12">
                <div className="">
                  <label>
                    Name
                    <span className="text-danger fw-bold">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    {...register("name", {
                      required: true,
                    })}
                    disabled={true}
                  />
                  {errors.name && (
                    <div className="error_line">Name is required</div>
                  )}
                </div>
              </div>
              <div className="col-12">
                <div className="">
                  <label>
                    Comment/Remark
                    <span className="text-danger fw-bold">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    {...register("remark", {
                      required: true,
                    })}
                    rows={5}
                  ></textarea>
                  {errors.remark && (
                    <div className="error_line">Comment/Remark is required</div>
                  )}
                </div>
              </div>
              <div className="col-12">
                <div className="">
                  <label>Upload supporting file (if any)</label>
                  <input
                    className="form-control"
                    type="file"
                    {...register("document")}
                  />
                  {errors.document && (
                    <div className="error_line">
                      Supporting file is required
                    </div>
                  )}
                </div>
              </div>

              <div className="col-12">
                <div className="">
                  <label>
                    Select Action <span className="text-danger fw-bold">*</span>
                  </label>
                  <select
                    className="form-select"
                    {...register("status", {
                      required: true,
                    })}
                  >
                    <option value="">Select Action</option>
                    <option value="2">Revert to DPA for Review</option>
                    <option value="3">Verified & Submitted</option>
                    <option value="7">Application Rejected</option>
                    {(selectedData.amount === 0 || selectedData.amount === "0" || selectedData.amount === null || selectedData.amount === "") && (
                      <option value="12">Paid from ERF</option>
                    )}
                  </select>
                  {errors.status && (
                    <div className="error_line">Status is required</div>
                  )}
                </div>
              </div>

              <div className="col-12">
                <div className="d-flex gap-2">
                  <button
                    type="submit"
                    className="btn btn-primary px-5"
                    disabled={isLoading}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </ModalBox>
    </>
  );
};

export default VerifyApplications;
